import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as retellLectureServices from '@iso/services/speaking/retellLecture';

//#region CRUD
export function* getRetellLecture() {
	yield takeLatest(actions.GET_RETELL_LECTURE, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(retellLectureServices.getRetellLecture, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_RETELL_LECTURE_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.SPEAKING_LOADING_FALSE,
			});
		}
	});
}

export function* getRetellLectureDetail() {
	yield takeLatest(actions.GET_RETELL_LECTURE_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(retellLectureServices.getRetellLectureDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_RETELL_LECTURE_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.SPEAKING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesRetellLecture() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_RETELL_LECTURE, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(retellLectureServices.createQuesRetellLecture, body);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			}
		}
	});
}

export function* updateRetellLectureDetail() {
	yield takeLatest(actions.UPDATE_RETELL_LECTURE_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(retellLectureServices.updateRetellLectureDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteRetellLecture() {
	yield takeLatest(actions.DELETE_RETELL_LECTURE, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(retellLectureServices.deleteRetellLecture, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getRetellLecture),
		fork(getRetellLectureDetail),
		fork(createQuesRetellLecture),
		fork(updateRetellLectureDetail),
		fork(deleteRetellLecture),
	]);
}
